<template>
  <section>
    <h5 v-if="!showMinimal">{{details.name}}</h5>
    <b-card no-body v-bind:class="{ 'mb-0 border-0': showMinimal }">
      <h6 v-if="showMinimal" class="card-subtitle mt-2 pl-2 pb-2">{{details.name}}</h6>

      <b-list-group flush>
        <b-list-group-item v-for="item in items" :item="item" :key="item.dclIdentity">
          <service-document-item
            :item="item"
            :showMinimal="showMinimal"
            :serviceId="details.id"
            @removedDocument="removedDocument"
          ></service-document-item>
        </b-list-group-item>
        <b-list-group-item v-if="items.length === 0" class="p-2">
          <small>{{ $t('SERVICES.NO_DOCUMENTS')}}</small>
        </b-list-group-item>
      </b-list-group>

      <b-card-footer class="text-center" v-if="!showMinimal">
        <b-nav v-if="!showMinimal">
          <select-document version="0" @selectedDocument="selectedDocument">
            <b-nav-item>
              <i class="fa fa-plus"></i>
              {{ $t('SERVICES.ADD_DOCUMENT')}}
            </b-nav-item>
          </select-document>

          <b-nav class="ml-auto">
            <b-nav-item
              @click="showEditSection"
              v-b-tooltip.hover
              :title="$t('SERVICES.EDIT.CONFIGURE')"
            >
              <i class="fal fa-tools"></i>
              <span>{{ $t('SERVICES.EDIT.CONFIGURE')}}</span>
            </b-nav-item>
            <b-nav-item :id="'popover-archive-' + details.id" v-b-tooltip.hover :title="archiveServiceText">
              <i
                class="fal"
                v-bind:class="{ 'fa-archive': details.archived == 0, 'fa-cubes': details.archived == 1 }"
              ></i>
              <span>{{ archiveServiceText }}</span>

              <b-popover
          :target="'popover-archive-' + details.id"
          :show.sync="popoverArchive"
          triggers="click"
          placement="auto"
        >
          <template v-slot:title>{{$t('CONFIRM')}}</template>
          <b-button @click="popoverArchive = false" size="sm" variant="secondary">{{$t('NO')}}</b-button>
          <b-button @click="archiveService" size="sm" variant="primary">{{$t('YES')}}</b-button>
        </b-popover>

            </b-nav-item>
          </b-nav>
        </b-nav>
      </b-card-footer>
    </b-card>

    <b-modal v-model="modalSectionEdit" centered no-fade v-if="!showMinimal">
      <div slot="modal-header" class="w-100">{{$t('SERVICES.EDIT.TITLE')}}</div>
      <div class="p-4">
        <form v-on:submit.prevent="onSubmit">
          <div class="form-group row">
            <label class="col-form-label">{{ $t('SERVICES.EDIT.INPUT_NAME') }}</label>
            <b-input
              autofocus
              v-on:keyup.enter="updateService"
              v-model="editName"
              type="text"
              name="name"
              required
            ></b-input>
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-button class="btn-fill" variant="secondary" @click="hideEditSection">{{ $t('CLOSE')}}</b-button>
        <b-button
          class="float-right btn-fill"
          id="popover-remove"
          variant="danger"
        >{{ $t('SERVICES.EDIT.REMOVE_DOCUMENT')}}</b-button>
        <b-button
          class="btn-fill"
          variant="primary"
          v-if="editedData"
          @click="updateService"
        >{{ $t('SERVICES.EDIT.SAVE')}}</b-button>

        <b-popover
          target="popover-remove"
          :show.sync="popoverShow"
          triggers="click"
          placement="auto"
        >
          <template v-slot:title>{{$t('CONFIRM')}}</template>
          <b-button @click="popoverShow = false" size="sm" variant="secondary">{{$t('CLOSE')}}</b-button>
          <b-button @click="removeService" size="sm" variant="primary">{{$t('YES')}}</b-button>
        </b-popover>         
      </div>
    </b-modal>
  </section>
</template>
<script>
import SelectDocument from "../Ledger/SelectDocument";
import ServiceDocumentItem from "./ServiceDocumentItem";

export default {
  components: {
    SelectDocument,
    ServiceDocumentItem
  },
  props: ["item", "minimal"],
  data() {
    return {
      details: this.item,
      showMinimal: this.minimal,
      dclIdentity: "",
      modalSectionEdit: false,
      editName: "",
      page: 0,
      limit: 25,
      items: [],
      totalItems: 0,
      popoverShow: false,
      popoverArchive: false
    };
  },
  methods: {
    removedDocument() {
      this.getDocuments();
    },
    selectedDocument(dclIdentity) {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/services/documents/add", {
          serviceId: this.details.id,
          dclIdentity: dclIdentity
        })
        .then(function() {
          self.getDocuments();
          self.$noty.info(self.$t("SERVICES.ADDED_DOCUMENT"));
        })
        .catch(function() {
          self.$noty.error(self.$t("SERVICES.ERROR.CANNOT_ADD_DOCUMENT"));
        });
    },
    onSubmit(event) {
      event.preventDefault();
    },
    showEditSection() {
      this.modalSectionEdit = true;
    },
    hideEditSection() {
      this.editName = this.details.name;
      this.modalSectionEdit = false;
    },
    getDocuments: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/services/documents/list", {
          serviceId: this.details.id,
          page: this.page,
          limit: this.limit
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    },
    archiveService: function() {
      this.details.archived = this.details.archived ? 0 : 1;
      this.popoverArchive = false;
      this.updateService();
    },
    updateService: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/services/update", {
          serviceId: this.details.id,
          name: this.editName,
          archived: this.details.archived
        })
        .then(response => {
          self.editName = response.data.name;
          self.details.name = response.data.name;
          self.details.archived = response.data.archived;
          this.$emit("updated", this.details);
          self.$noty.info(
            self.$t("SERVICES.SUCCESS.UPDATED") + " " + response.data.name
          );
          self.hideEditSection();
        })
        .catch(error => {
          self.$noty.error(self.$t(error.data.message));
        });
    },
    removeService: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/services/remove", {
          serviceId: this.details.id
        })
        .then(response => {
          this.$emit("removed", this.details);
          self.$noty.info(
            self.$t("SERVICES.SUCCESS.REMOVED") + " " + response.data.name
          );
          self.hideEditSection();
        })
        .catch(error => {
          self.$noty.error(self.$t(error.data.message));
        });
    }
  },
  computed: {
    archiveServiceText() {
      if (this.details.archived === 0) {
        return this.$t("SERVICES.EDIT.ARCHIVE");
      } else {
        return this.$t("SERVICES.EDIT.RESTORE");
      }
    },
    editedData() {
      if (this.details.name != this.editName) {
        return true;
      }
      return false;
    }
  },
  mounted: function() {
    this.editName = this.details.name;
    this.getDocuments();
  }
};
</script>
<style>
</style>
